import { formatMoney } from 'lib/functions/utils';
import { Warranty } from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import { Dispatch } from 'redux';

// Base interface for all operation types
export interface BaseOperation {
  id: number;
  businessIdentifier: string;
  createdAt: string;
  updatedAt: string;
}

// Configuration for operation types
export interface OperationTypeConfig {
  key: string;
  label: string;
  apiEndpoint: string;
  tableHeaders: Array<{
    label: string;
    key: string;
    type?: string;
  }>;
  getLabel: (operation: BaseOperation) => string;
  fetchData: (
    dispatch: Dispatch,
    page: number,
    pageSize: number,
    businessIdentifier: string | undefined,
  ) => Promise<{ data: BaseOperation[]; pagination: Pagination }>;
}

// Operation type registry
export const OPERATION_TYPES: Record<string, OperationTypeConfig> = {
  'warranty-request': {
    key: 'warranty-request',
    label: 'Garantías',
    apiEndpoint: 'internal/sgrWarrantyRequest',
    tableHeaders: [
      {
        label: 'ID',
        key: 'id',
        type: 'numeric-id',
      },
      {
        label: 'Tipo',
        key: 'translatedType',
      },
      {
        label: 'Cliente',
        key: 'businessName',
      },
      {
        label: 'Estado',
        key: 'translatedStatus',
        type: 'status',
      },
      {
        label: 'Monto Cotizado',
        key: 'quotedAmount',
        type: 'money',
      },
      {
        label: 'Moneda',
        key: 'quotedCurrency',
      },
      {
        label: 'Costo de emisión',
        key: 'premium',
        type: 'money',
      },
    ],
    getLabel: (operation: BaseOperation) =>
      `Garantía ${operation.id} - Costo de emisión: ${formatMoney((operation as Warranty).premium ?? 0)}`,
    fetchData: async (dispatch, page, pageSize, businessIdentifier) => {
      const { getAllSGRWarrantyRequests } = await import('lib/api/sgr');
      const query = `page=${page}&pageSize=${pageSize}&businessIdentifier=${businessIdentifier}`;
      return await getAllSGRWarrantyRequests(dispatch, query);
    },
  },
};

// Unified operation association value
export interface OperationAssociationValue {
  enabled: boolean;
  operationType?: string;
  operation?: BaseOperation;
}
